import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { EntityTypes } from '../../../constants/entities';
import { IEntityReducer } from 'core/reducers/entities';
import { ICourse, ICourseDAO, ICourseVariable, ICourseVariableDAO } from 'types/domain/course';
import { getEntities } from '../utils/getEntities';
import { parseVariableDAO } from './variable';
import { createCachedSelector } from 're-reselect';

const entity = (state: RootState) => state.entity.present;
const id = (state: RootState, id?: number) => (id ? id : state.state[EntityTypes.COURSE]);
const courseId = (state: RootState) => state.session.courseId;

export const selectCourse = createCachedSelector(
  entity,
  id,
  parseCourseDAO,
)((state, id) => id || state.state[EntityTypes.COURSE] || 'unknown');

export function parseCourseDAO(entity: IEntityReducer, id: number) {
  const course: ICourse = entity[EntityTypes.COURSE][id];

  if (!course) return null;

  const nodes = getEntities(entity, EntityTypes.COURSE_NODE, 'courseId', id);

  return {
    ...course,
    text: course.textId ? entity[EntityTypes.TEXT][course.textId] : null,
    image: course.imageId
      ? {
          ...entity[EntityTypes.IMAGE][course.imageId],
          files: getEntities(entity, EntityTypes.IMAGE_FILE, 'imageId', course.imageId),
        }
      : null,
    nodes,
    tags: getEntities(entity, EntityTypes.TAG_JOIN, 'courseId', course.id),
    outs: getEntities(entity, EntityTypes.COURSE_OUT, 'courseId', id),
    courseVariables: getEntities(entity, EntityTypes.COURSE_VARIABLE, 'courseId', id).map((cv: ICourseVariable) => {
      return { ...cv, variable: parseVariableDAO(entity, cv.variableId) } as ICourseVariableDAO;
    }),
  } as ICourseDAO;
}

export const selectIsDefaultCourse = createSelector(courseId, id, (courseId, id) => courseId === id);

export const selectCourseName = createSelector(
  entity,
  id,
  (entity, id) => entity[EntityTypes.COURSE][id]?.name || entity[EntityTypes.TEXT][entity[EntityTypes.COURSE][id]?.textId]?.shortText,
);
